import type { Company } from "@prisma/client";
import parseDate from "~/kernel/dateTime/parseDate";
import tryParseDate from "~/kernel/dateTime/tryParseDate";
import transform from "~/kernel/objects/transform";
import type SerializeType from "~/kernel/server/SerializeType";

export default function deserializeCompany(
  company: SerializeType<Company>,
): Company {
  return transform(company, {
    subscriptionEndsAt: tryParseDate,
    createdAt: parseDate,
    updatedAt: parseDate,
    deletedAt: tryParseDate,
    verificationStatusChangedAt: parseDate,
    geocodedAt: tryParseDate,
  });
}
